import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=4dcaf684&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=4dcaf684&prod&lang=scss&scoped=true&"
import style1 from "./upload.vue?vue&type=style&index=1&id=4dcaf684&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcaf684",
  null
  
)

export default component.exports